export * from "./Calendar"
export * from "./Discord"
export * from "./Facebook"
export * from "./FacebookMessenger"
export * from "./Instagram"
export * from "./Linkedin"
export * from "./Mail"
export * from "./Telegram"
export * from "./Twitch"
export * from "./Twitter"
export * from "./Whatsapp"
export * from "./filePdf"
export * from "./fileDoc"
export * from "./Youtube"
export * from "./Arrow-top"
export * from "./Arrow-right"
export * from "./Arrow-left"
export * from "./Arrow-select"
export * from "./Phone"
export * from "./Axapharm"
export * from "./Mepha"
export * from "./Sandoz"
export * from "./Search"
export * from "./SymbolLink"
export * from "./Symbols"
export * from "./VideoPlay"
export * from "./Geolocalize"
export * from "./Delivery"
export * from "./Website"
export * from "./Zentiva"
